import React from 'react'
import { observer } from 'mobx-react-lite'
import Grid from '@mui/material/GridLegacy'
import { Box } from '@mui/material'

import { useStores } from '@trivie/core'
import { color } from '@trivie/ui-web/theme'
import { Panel } from '@trivie/ui-web/components/panel/panel'
import { Insight } from '@trivie/ui-web/components/insight'

import { SubscriptionPurchasesTable } from '../subscription-purchases-table'

const PurchasesTabContent = observer(() => {
  const { subscriptionStore } = useStores()
  const { active, expired, failed, total } = subscriptionStore.purchaseStats

  return (
    <>
      <Grid container spacing={2} mb={2}>
        <Grid xs={12} item md={6} lg={3} sx={{ width: '100%' }}>
          <Panel fill sx={{ flex: 1 }}>
            <Insight title="Active" value={String(active)} textStyle={{ color: color.green }} />
          </Panel>
        </Grid>
        <Grid item xs={12} md={6} lg={3} sx={{ width: '100%' }}>
          <Panel fill sx={{ flex: 1 }}>
            <Insight title="Expired" value={String(expired)} textStyle={{ color: '#888' }} />
          </Panel>
        </Grid>
        <Grid item xs={12} md={6} lg={3} sx={{ width: '100%' }}>
          <Panel fill sx={{ flex: 1 }}>
            <Insight title="Failed" value={String(failed)} textStyle={{ color: color.red }} />
          </Panel>
        </Grid>
        <Grid item xs={12} md={6} lg={3} sx={{ width: '100%' }}>
          <Panel fill sx={{ flex: 1 }}>
            <Insight title="Total" value={String(total)} />
          </Panel>
        </Grid>
      </Grid>
      <Box pb="40px">
        <SubscriptionPurchasesTable variant="all" />
      </Box>
    </>
  )
})

export const SubscriptionPurchasesTab = () => {
  return {
    name: 'Purchases',
    path: `/activities/subscriptions/purchases`,
    component: () => <PurchasesTabContent />,
  }
}
